var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-card uk-card-default uk-card-body uk-margin-small uk-padding-small uk-border-rounded uk-box-shadow-medium"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }